/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import { cloneDeep } from 'lodash';

import { GeneralSection } from "../../general/index";

function handleInitialAdjustments ({
  questionnaire,
  teams,
  setFieldValue
}) {
  const [contactsGroupQst] = GeneralSection.events.groupMultipleFieldQuestions(
    2189,
    questionnaire
  );

  const contactsGroup = teams.map(team => {
    const contactsQst = team.contacts.map(contact => {
      const questions = cloneDeep(contactsGroupQst);
      return questions.map(qst => {
        if (qst.idQuestion === 2189) {
          const contactName = JSON.stringify({
            id: contact.person.idPerson,
            value: `${contact.person.personFirstName} ${contact.person.personLastName}`
          });
          qst.answer = contactName;
          qst.answerJson = contactName;
          qst.idPersonRelationship = contact.idPersonRelationship;
        } else if (qst.idQuestion === 2190) {
          qst.answer = contact.jobTitle;
          setFieldValue && setFieldValue(qst.key, qst.answer);
        } else if (qst.idQuestion === 2191) {
          qst.answer = contact.email;
          setFieldValue && setFieldValue(qst.key, qst.answer);
        } else if (qst.idQuestion === 2192) {
          qst.answer = contact.phone;
          setFieldValue && setFieldValue(qst.key, qst.answer);
        }
        return qst;
      });
    });
    
    return {
      teamName: team.personFirstName,
      idPersonTeam: team.idPerson,
      contacts: contactsQst.length ? contactsQst : [cloneDeep(contactsGroupQst)]
    };
  });

  return contactsGroup;
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
}) {
  try {
    let saveQuestionnaire = false;
    if (question.idQuestion === 2189) {
      saveQuestionnaire = true;
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (!value) {
          qst.answer = ''
          qst.answerJson = '';
          qst.idAnswerOption = null;
          setFieldValue && setFieldValue(qst.key, '');
          return qst;
        }

        if(value?.id) {
          if (qst.idQuestion === 2190) {
            qst.answer = value.jobTitle;
            setFieldValue && setFieldValue(qst.key, qst.answer);
          } else if (qst.idQuestion === 2191) {
            qst.answer = value.email;
            setFieldValue && setFieldValue(qst.key, qst.answer);
          } else if (qst.idQuestion === 2192) {
            qst.answer = value.phone;
            setFieldValue && setFieldValue(qst.key, qst.answer);
          }
        }

        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('CONTACTS - handleQuestionChange - error', e)
  }
};

const events = {
  handleQuestionChange,
  handleInitialAdjustments
};

export { events };